import { render, staticRenderFns } from "./Supplements.vue?vue&type=template&id=021eb91d&scoped=true"
import script from "./Supplements.vue?vue&type=script&lang=js"
export * from "./Supplements.vue?vue&type=script&lang=js"
import style0 from "./Supplements.vue?vue&type=style&index=0&id=021eb91d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021eb91d",
  null
  
)

export default component.exports